<template>
  <div id="app">
    <img id="background_cover" src="staytion-yellow.png" alt="Staytion Background"/>
      <router-view/>
  </div>
</template>

<script>

export default {}

</script>

<style>
* {
  color:#fff;
  text-decoration: none;
  font-family: proxima-nova, sans-serif;
}

img {
  z-index: -1;
}

#background_cover {
  position: absolute;
  right: 0px;
  bottom: 0px;
  height: 100%;
  opacity: 0.5;
}


#tag-line {
  opacity: 0.8;
}


@media only screen and (max-device-width : 750px) {
  #background_cover {
    opacity: 0.2;
  }
}

@media only screen and (min-device-width : 750px) {}

</style>
